import { type ComponentType } from 'react';
import { type SerializedError } from '@reduxjs/toolkit';
import { type FetchBaseQueryError } from '@reduxjs/toolkit/dist/query';
import { ShowError } from 'src/shared/components/ShowError';
import { ShowLoading } from 'src/shared/components/ShowLoading';

type DataHandlingProps = {
  isLoading: boolean;
  isError: boolean;
  error: FetchBaseQueryError | SerializedError | Error | undefined;
  data: unknown;
};

export const withDataHandling = <T extends DataHandlingProps>(WrappedComponent: ComponentType<T>) => {
  return function WithDataHandling(props: T) {
    const { isLoading, isError, error, data, ...rest } = props;

    return (
      <div>
        {isLoading ? (
          <ShowLoading />
        ) : isError ? (
          <ShowError error={error} />
        ) : (
          <WrappedComponent {...(rest as T)} data={data ?? []} />
        )}
      </div>
    );
  };
};
